import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { EditTaskLocationComponent } from './edit-task-location.component';
import { WarningContainerComponent } from '../create-movement-job/warning-container/warning-container.component';

const routes: Routes = [
  { path: '', component: EditTaskLocationComponent, data: { title: 'Edit Task Location' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EditTaskLocationRoutingModule {}

@NgModule({
  imports: [
    EditTaskLocationRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    WarningContainerComponent,
  ],
  declarations: [EditTaskLocationComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class EditTaskLocationModule {}
